export const CALL_OUT_TO_TAB = 'call-out-to-tab';
export const FLOOR_SELECTOR = 'floor-selector';
export const SUPPORTED_CUSTOM_COMPONENTS = [CALL_OUT_TO_TAB, FLOOR_SELECTOR];
